import { createReducer, on } from '@ngrx/store';
import {
    setDBInitial, clearDBInitial,
    setBuid, clearBuid,
    setuserRoleId, clearuserRoleId,
    setuserRole, clearuserRole,
    setuserId, clearuserId,
    setorganizationId, clearorganizationId,
    setcompanyId, clearcompanyId,
    setcountryId, clearcountryId,
    setStartDate, clearStartDate,
    setEndDate, clearEndDate,
    logoutClearState,
    setLicId,
    setsessionId,
    setlicenseDay,
    clearLicId,
    clearuserCategoryId,
    setuserCategoryId,
    setIsFileAttachment,
    clearIsFileAttachment,
    setIsPastDateAllowed,
    clearIsPastDateAllowed,
    clearNoOfPastDatesAllowed,
    setNoOfPastDatesAllowed,
} from './buid.actions';
export interface AppState {
    dbInitialState: BuidState;
    buidState: BuidState;
    userRoleIdState: BuidState;
    userRoleState: BuidState;
    userIdState: BuidState;
    organizationIdState: BuidState;
    companyIdState: BuidState;
    countryIdState: BuidState;
    startDateState: BuidState;
    endDateState: BuidState;
    licIdState: BuidState;
    isPastDateAllowedState: BuidState;
    noOfPastDatesAllowedState: BuidState;
}
export interface BuidState {
    DBInitial: string | null;
    BUID: string | null;
    userRoleId: string | null;
     userRole: string | null;
    userCategoryId: string | null;
    userId: string | null;
    organizationId: string | null;
    companyId: string | null;
    countryId: string | null;
    startDate: string | null;
    endDate: string | null;
    licId: string | null;
    licenseDay: string | null;
    isFileAttachment: boolean | null;
    isPastDateAllowed: boolean | null;
    noOfPastDatesAllowed: number | null;
}

export const initialState: BuidState = {
    DBInitial: localStorage.getItem('DBInitial'),
    BUID: localStorage.getItem('BUID'),
    userRoleId: localStorage.getItem('userRoleId'),
    userRole: localStorage.getItem('userRole'),
     userCategoryId: localStorage.getItem('userCaegoryId'),
    userId: localStorage.getItem('userId'),
    organizationId: localStorage.getItem('organizationId'),
    companyId: localStorage.getItem('companyId'),
    countryId: localStorage.getItem('countryId'),
    startDate: localStorage.getItem('StartDate'),
    endDate: localStorage.getItem('EndDate'),
    licId: localStorage.getItem('LicId'),
    licenseDay: localStorage.getItem('licenseDay'),
     isFileAttachment: localStorage.getItem('isFileAttachment') === 'true',
    isPastDateAllowed: localStorage.getItem('isPastDateAllowed') === 'true',
    noOfPastDatesAllowed: localStorage.getItem('noOfPastDatesAllowed') ? Number(localStorage.getItem('noOfPastDatesAllowed')) : null,
};

export const buidReducer = createReducer(
    initialState,

    // Set Actions
    on(setBuid, (state, { BUID }) => {
        localStorage.setItem('BUID', BUID);
        return { ...state, BUID };
    }),
    on(setDBInitial, (state, { DBInitial }) => {
        localStorage.setItem('DBInitial', DBInitial);
        return { ...state, DBInitial };
    }),
    on(setuserRoleId, (state, { userRoleId }) => {
        localStorage.setItem('userRoleId', userRoleId);
        return { ...state, userRoleId };
    }),

    on(setuserRole, (state, { userRole }) => {
        localStorage.setItem('userRole', userRole);
        return { ...state, userRole };
    }),

      on(setuserCategoryId, (state, { userCategoryId }) => {
        localStorage.setItem('userCategoryId', userCategoryId);
        return { ...state, userCategoryId };
    }),

    on(setuserId, (state, { userId }) => {
        localStorage.setItem('userId', userId);
        return { ...state, userId };
    }),
    on(setorganizationId, (state, { organizationId }) => {
        localStorage.setItem('organizationId', organizationId);
        return { ...state, organizationId };
    }),
    on(setcompanyId, (state, { companyId }) => {
        localStorage.setItem('companyId', companyId);
        return { ...state, companyId };
    }),

      on(setcountryId, (state, { countryId }) => {
        localStorage.setItem('countryId', countryId);
        return { ...state, countryId };
    }),

    on(setStartDate, (state, { startDate }) => {
        localStorage.setItem('StartDate', startDate);
        return { ...state, startDate };
    }),
    on(setEndDate, (state, { endDate }) => {
        localStorage.setItem('EndDate', endDate);
        return { ...state, endDate };
    }),
    on(setLicId, (state, { licId }) => {
        localStorage.setItem('LicId', licId);
        return { ...state, licId };
    }),
on(setIsFileAttachment, (state, { isFileAttachment }) => {
        localStorage.setItem('isFileAttachment', String(isFileAttachment));
        return { ...state, isFileAttachment };
    }),
    on(setIsPastDateAllowed, (state, { isPastDateAllowed }) => {
        localStorage.setItem('isPastDateAllowed', String(isPastDateAllowed));
        return { ...state, isPastDateAllowed };
    }),

    on(setNoOfPastDatesAllowed, (state, { noOfPastDatesAllowed }) => {
        localStorage.setItem('noOfPastDatesAllowed', String(noOfPastDatesAllowed));
        return { ...state, noOfPastDatesAllowed };
    }),
    on(setsessionId, (state, { sessionId }) => {
        localStorage.setItem('UsersessionId', sessionId);
        return { ...state, sessionId };
    }),

     on(setlicenseDay, (state, { licenseDay }) => {
        localStorage.setItem('licenseDay', licenseDay);
        return { ...state, licenseDay };
    }),

    // Clear Actions
    on(clearBuid, (state) => {
        localStorage.removeItem('BUID');
        return { ...state, BUID: null };
    }),
    on(clearDBInitial, (state) => {
        localStorage.removeItem('DBInitial');
        return { ...state, DBInitial: null };
    }),
    on(clearuserRoleId, (state) => {
        localStorage.removeItem('userRoleId');
        return { ...state, userRoleId: null };
    }),

      on(clearuserCategoryId, (state) => {
        localStorage.removeItem('userCategoryId');
        return { ...state, userCategoryId: null };
    }),
    on(clearuserId, (state) => {
        localStorage.removeItem('userId');
        return { ...state, userId: null };
    }),
    on(clearorganizationId, (state) => {
        localStorage.removeItem('organizationId');
        return { ...state, organizationId: null };
    }),
    on(clearcompanyId, (state) => {
        localStorage.removeItem('companyId');
        return { ...state, companyId: null };
    }),
    on(clearStartDate, (state) => {
        localStorage.removeItem('StartDate');
        return { ...state, startDate: null };
    }),
    on(clearEndDate, (state) => {
        localStorage.removeItem('EndDate');
        return { ...state, endDate: null };
    }),
    on(clearLicId, (state) => {
        localStorage.removeItem('LicId');
        return { ...state, licId: null };
    }),
    on(clearIsFileAttachment, (state) => {
        localStorage.removeItem('isFileAttachment');
        return { ...state, isFileAttachment: null };
    }),
    on(logoutClearState, () => {
        localStorage.removeItem('DBInitial');
        localStorage.removeItem('BUID');
        localStorage.removeItem('userRoleId');
        localStorage.removeItem('userRole');
          localStorage.removeItem('userCaegoryId');
        localStorage.removeItem('userId');
        localStorage.removeItem('organizationId');
        localStorage.removeItem('companyId');
        localStorage.removeItem('countryId');
        localStorage.removeItem('StartDate');
        localStorage.removeItem('EndDate');
        localStorage.removeItem('LicId');
        localStorage.removeItem('isFileAttachment');
        localStorage.removeItem('isPastDateAllowed');
        return {
            ...initialState,
            DBInitial: null,
            BUID: null,
             userCategoryId: null,
            userRoleId: null,
            userRole: null,
            userId: null,
            organizationId: null,
            companyId: null,
            countryId: null,
            startDate: null,
            endDate: null,
            licId: null,
            isFileAttachment: null,
            isPastDateAllowed: null,
            noOfPastDatesAllowed: null,
        };
    })
);
